export const PatreonLogo: React.FC = () => {
    return (
        <svg id="patreon-logo" width="157" height="150" viewBox="0 0 157 150" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="27.5148" height="150" />
            <circle cx="100.148" cy="56.3609" r="56.3609" />
        </svg>
    );
}